import { render, staticRenderFns } from "./aspage.vue?vue&type=template&id=60e5bfbf&scoped=true&"
import script from "./aspage.vue?vue&type=script&lang=js&"
export * from "./aspage.vue?vue&type=script&lang=js&"
import style0 from "./aspage.vue?vue&type=style&index=0&id=60e5bfbf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e5bfbf",
  null
  
)

export default component.exports